import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';

import { SharedModule } from "@bt/shared";
import { BrandModule } from "../brand/brand.module";

import { RegistrationComponent } from './registration.component';
import { RegistrationFormComponent } from "./form/component";
import { RegistrationService } from "./registration.service";

@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        SharedModule,
        BrandModule
    ],
    declarations: [
        RegistrationComponent,
        RegistrationFormComponent
    ],
    providers: [
        RegistrationService
    ]
})
export class RegistrationModule { }


// WEBPACK FOOTER //
// ./src/app/public/registration/registration.module.ts